import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-counter-strike',
  templateUrl: './counter-strike.component.html',
  styleUrls: ['./counter-strike.component.css']
})
export class CounterStrikeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
